import withReducer from '../../store/withReducer'
import Dashboard from './container'
import reducer from './module'

export default withReducer('dashboard', reducer)(Dashboard)



// WEBPACK FOOTER //
// ./src/legacy/pages/Dashboard/index.js